import { all, fork } from "redux-saga/effects";
import getUserFunctions from "./getUserFunctions";

const { getUserRequest } = getUserFunctions;

export default function* rootSaga() {
  yield all([fork(getUserRequest)]);
}
